import { render, staticRenderFns } from "./EventTypeAddEditModal.vue?vue&type=template&id=f1b6e196&"
import script from "./EventTypeAddEditModal.vue?vue&type=script&lang=js&"
export * from "./EventTypeAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports